import PushpinIcon from "@/assets/images/PushpinIcon";

interface PinButtonProps {
  toggleSidebar?: () => void;
}

export default function PinButton({ toggleSidebar }: PinButtonProps) {
  return (
    <button
      onClick={toggleSidebar}
      aria-label="minimize_sidebar"
      className="bg-extended-pgadarknavy-brand-color rounded-full w-10 h-10 flex items-center justify-center text-extended-pgadarknavy-brand-on-color"
    >
      <PushpinIcon size={20} />
    </button>
  );
}
